module.exports = __webpack_public_path__ + "img/Rectangle 6.35b845c2.png";